import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Poppers from "@mui/material/Popper";
import { StyledComponentProps } from "@mui/styles";
import { HeaderStylesClassKey } from "assets/jss/layouts/headerLinksStyle";
import classNames from "classnames";
import MuiRegularButton from "components/MuiExtras/Button/MuiRegularButton";
import { AccessKeys } from "Constants";
import * as React from "react";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
}

interface IProps {
    icon: React.ReactElement | string;
    accessKey?: string;
    tooltip?: string;
    counter?: number;
    open: boolean;
    handleClose: (e: MouseEvent | TouchEvent) => void;
    handleToggle: () => void;
}

type Props = IProps & StyledComponentProps<HeaderStylesClassKey>;

/////////////////////////////////////////////////////////////////////////////////////////////////


class HeaderLinkButton extends React.Component<Props, IState> {

    private refEl: HTMLElement;

    constructor(props: Props) {
        super(props);
        this.state = {
            open: false
        };
    }

    private handleOuterClick = (event: MouseEvent | TouchEvent) => {
        const target = event.target as HTMLElement;

        if (this.refEl.contains(target)) {
            return;
        }

        this.props.handleClose(event);
    };


    public render() {
        const { accessKey, classes, icon, counter, open, tooltip } = this.props;
        return (
            <div className={classes.manager} title={tooltip}>
                <MuiRegularButton
                    color={"transparent"}
                    aria-expanded={open}
                    aria-haspopup="true"
                    accessKey={accessKey}
                    onClick={
                        (e) => {
                            this.refEl = e.currentTarget;
                            this.props.handleToggle();
                        }
                    }
                    className={classes.buttonMenu}
                >
                    {
                        typeof (icon) == "string"
                            ? <img src={icon as string} width={24} height={24} key={"HeaderUserImg"} alt={tooltip} />
                            : icon
                    }
                    {counter != null && counter > 0 ? (<span className={classes.notifications}>{counter}</span>) : null}
                </MuiRegularButton>
                <Poppers
                    open={open}
                    anchorEl={this.refEl}
                    transition
                    disablePortal
                    className={classNames(classes.pooperNav, { [classes.popperClose]: !open })}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={
                                {
                                    transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                                }
                            }
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={this.handleOuterClick}>
                                    <div>
                                        {this.props.children}
                                    </div>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Poppers>
            </div>
        );
    }
}


export default HeaderLinkButton;
